// extracted by mini-css-extract-plugin
export default {"container":"FoodDonationApp_container__1BRKv"};